import React from "react";
import RankKeyword from "./RankKeyword";

/** 사이드바「키워드 분석」전용 페이지 */
const KeywordAnalysis = () => <RankKeyword variant="keywordAnalysis" />;

export default KeywordAnalysis;
